export enum StateActionStatus {
  DEFAULT = 'default',
  DISPATCH = 'dispatch',
  SUCCESS = 'success',
  ERROR = 'error',
}
